module.exports = __webpack_public_path__ + "static/img/ldsc.8e061f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/ldsc.png
// module id = hs5J
// module chunks = 0